// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue';
import App from './App';
import router from './router';
import VueI18n from 'vue-i18n';
// 【Custom Plugins】
// Import Cognito Plugins..
import Cognito from './custom_plugins/auth/cognito';
import Login from './custom_plugins/auth/login';
import InvokeUrlMaker from './custom_plugins/invoke/url_maker';
// 【Constants】
import texts from '../common/src/constrains/locale/texts';
import vuetify from './plugins/vuetify';
import InfiniteLoading from 'vue-infinite-loading';
import VueAnalytics from 'vue-analytics';
import SocialSharing from 'vue-social-sharing';
import VueGtm from 'vue-gtm';
Vue.use(VueGtm, {
    id: 'GTM-PTXN96S',
    // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    enabled: true,
    // Whether or not display console logs debugs (optional)
    // debug: true,
    vueRouter: router
});
Vue.use(SocialSharing);

Vue.use(VueAnalytics, {
    id: 'UA-109504692-1'
});
Vue.use(VueI18n);
// Create VueI18n instance with options
const i18n = new VueI18n({
    locale: 'ja',
    messages: texts
});
// 【Custom Plugin】
// Cognito Set up..
Vue.use(Cognito, process.env);
Vue.use(Login, process.env);

// Url Maker Set up...
Vue.use(InvokeUrlMaker, process.env);
Vue.use(InfiniteLoading);
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    i18n: i18n,
    router,
    Cognito,
    components: {App},
    vuetify,
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js